<script lang="ts">
export default {
  name: 'Specialist Filter',
  inheritAttrs: false,
  customOptions: {}
}
</script>

<script setup lang="ts">
  import { ref } from 'vue';
  import MultiSelect from 'primevue/multiselect';
  import FloatLabel from 'primevue/floatlabel';
  import Chip from 'primevue/chip';
  import InputText from 'primevue/inputtext';
  import { useGlobalStore } from '../../stores/global';

  const props = defineProps({
    categoryOptions: {
      type: Array<{id: number, name: string}>,
      required: true
    },
    trans: { type: Object, required: true },
  });

  const global = useGlobalStore();

  let category = ref();
  let postcode = ref(global.user.address.postcode);

  document.location.search.substring(1).split('&').forEach(v => {
    if (!v) {
      return;
    }
    let p = v.split('=');
    let ids = p[1].split(',').map((v: string) => parseInt(v, 10));
    if (p[0] === 'type') {
      category.value = props.categoryOptions.filter(option => ids.indexOf(option.id) > -1);
    }
    if (p[0] === 'postal-code') {
      postcode.value = decodeURIComponent(p[1]);
    }
  });

  function filter() {
    let s = '', r = '', url = '';
    if (category.value) {
      s = category.value.map((v: any) => v.id).join(',');
    }
    if (postcode.value) {
      r = postcode.value;
    }
    if (s) {
      url = '?' + `type=${s}`;
    }
    if (r) {
      if (url.length) {
        url = url + `&postal-code=${r}`;
      } else {
        url = `?postal-code=${r}`;
      }
    }
    document.location.href = document.location.pathname + (url ? url : '');
  }
</script>

<template>
  <div class="list-filters-inner">
    <FloatLabel>
      <MultiSelect id="specialist-category" v-model="category" :options="categoryOptions" optionLabel="name" :filter="false">
        <template #value>
          <span>{{ trans.label.num_selected.replace('{num}', category ? category.length.toString() : '0') }}</span>
        </template>
      </MultiSelect>
      <label for="franchise-sector">{{ trans.label.sector }}</label>
    </FloatLabel>

    <InputText id="specialist-region" v-model="postcode" type="text" :placeholder="trans.label.enter_postcode" />

    <button class="btn-solid" @click="filter">{{ trans.label.filter }}</button>
  </div>
  <div class="chip-list">
    <Chip v-if="category" v-for="s in category" :key="s.id" :label="s.name" removable @remove="category = category.filter((v: any) => v.id !== s.id)"></Chip>
  </div>
</template>
